module.exports = __webpack_public_path__ + "img/skinmask_step2.b345ee25.jpg";